import { AppState, AppThunkDispatch } from '../..';
import { QueueSubscriptionRequest } from '../../../entities/subscription-config-v1/models';
import SubscriptionConfig from '../../../services/subscription-config';
import { enqueueSnackbarAction } from '../../snackbar/actions';
import { getCommandsByDeviceKey } from '../actions';

export const sendSubscriptionToDevice =
  (subscriptionId: number | undefined, deviceKey: string) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const subscriptionConfig = new SubscriptionConfig(
      client,
      envVariables.subscriptionConfigV2BaseUrl,
    );
    const input: QueueSubscriptionRequest = {
      configs: [
        {
          deviceKey,
          subscription: {
            subscriptionId,
          },
        },
      ],
      wakeupType: 'all',
      wakeup: true,
    };
    try {
      if (subscriptionId) {
        const response = await subscriptionConfig.queueSubscriptions(input);
        if (response.status === 200) {
          dispatch(
            enqueueSnackbarAction({
              message: 'Send subscription to device operation successful',
              options: {
                key: (Date.now() + Math.random()).toString(),
                variant: 'success',
              },
            }),
          );
          dispatch(getCommandsByDeviceKey({ deviceKey, statuses: '1' }, true));
        } else {
          dispatch(
            enqueueSnackbarAction({
              message: 'Send subscription to device operation failed',
              options: { key: (Date.now() + Math.random()).toString(), variant: 'error' },
            }),
          );
        }
      }
    } catch (error) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Wakeup operation failed',
          options: { key: (Date.now() + Math.random()).toString(), variant: 'error' },
        }),
      );
    }
  };
